export function getEdTechKisaanBaseURL() {
  return process.env.APP_WORKFLOW_URI_V2;
}

function productCategoryList(payload) {
  let url = `${getEdTechKisaanBaseURL()}/kisaan/products/p/${payload.type}/list`;
  if (payload?.userId) {
    url += `?userId=${payload?.userId}`;
  }

  return url;
}

export function paymentBaseURL() {
  return process.env.APP_KISAN_URI;
}

const edTechPaths = {
  getProductList: () => `${getEdTechKisaanBaseURL()}/kisaan/products/p/list`,
  getProductCategory: (payload) => `${productCategoryList(payload)}`,
  getProductSubCategoriesList: (payload) =>
    `${getEdTechKisaanBaseURL()}/kisaan/products/p/${payload.type}/${payload.subType}/list`,
  getProductDetail: (payload: { category: string; id: string; user: { userId: string; userName: string; phoneNumber: string } }) =>
    `${getEdTechKisaanBaseURL()}/kisaan/products/p/${payload?.category}/${payload?.id}?userId=${payload?.user?.userId}&userName=${encodeURIComponent(payload?.user?.userName)}&phoneNumber=${payload?.user?.phoneNumber}`,
  getSimilarProductList: (payload) =>
    `${getEdTechKisaanBaseURL()}/kisaan/products/p/${payload.type}/${payload.subType}/${payload.id}/similar`,
  getInstructorDetail: (payload) =>
    `${getEdTechKisaanBaseURL()}/kisaan/products/p/course/provider/${payload?.instructorId}`,

  getInstructorProductList: (payload) =>
    `${getEdTechKisaanBaseURL()}/kisaan/products/p/course/provider/${payload?.instructorId}/products`,
  getProductSearch: () =>
    `${getEdTechKisaanBaseURL()}/kisaan/search/p/global`,
  getReviewList: (payload) =>
    `${getEdTechKisaanBaseURL()}/kisaan/reviews/p/${payload.entityType}/${payload.entityId}?offset=${payload.offset}&count=${payload.limit}`,
  getReviewSummary: (payload) => `${getEdTechKisaanBaseURL()}/kisaan/reviews/p/${payload.entityType}/${payload.entityId}/summary`,
  postProductReview: (type, id) => `${getEdTechKisaanBaseURL()}/kisaan/reviews/p/${type}/${id}`,
  getIsReviewExist: (payload) =>`${getEdTechKisaanBaseURL()}/kisaan/reviews/p/product/${payload.productId}/${payload.userId}?offset=0&count=10`,
  productCartValidation: () => `${(paymentBaseURL())}/kisaan/products/p/cart-order-payment`,
};

export default edTechPaths;
